import r from "./isFunction.js";
import n from "./isLength.js";
var t = r, o = n;
function s(i) {
  return i != null && o(i.length) && !t(i);
}
var f = s;
export {
  f as default
};
//# sourceMappingURL=isArrayLike.js.map
